import { NumberSymbol } from "@angular/common";

export class Clientes {
    key: number;
    codcliente: number;
    tipoidentificacion: string;
    numeroidentificacion: string;
    direccion: string;
    telefonoconvencional: string;
    extension: string;
    celular: string;
    correo: string;
    tipoCliente: string;
    nombrerazonsocial: string;
    credito_dolares:number;
    credito_tiempo:number;
    idEmisor: number;
    enviado: string;
    obligadoLlevarContabilidad:string;
    tipoCatalogo:string;

    }
    